'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishAvailabilityMessage = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _canSendNewOfficeHoursMessage = require('conversations-schema/thread-history/operators/canSendNewOfficeHoursMessage');

var _canSendNewTypicalResponseTimeMessage = require('conversations-schema/thread-history/operators/canSendNewTypicalResponseTimeMessage');

var _hasChatMessageFromAgent = require('conversations-schema/thread-history/operators/hasChatMessageFromAgent');

var _getConversations = require('../../selectors/conversationSelectors/getConversations');

var _getOfficeHoursStartTime = require('conversations-schema/availability/operators/getOfficeHoursStartTime');

var _getTypicalResponseTime = require('conversations-schema/availability/operators/getTypicalResponseTime');

var _publishOfficeHoursMessage = require('../../office-hours/actions/publishOfficeHoursMessage');

var _publishTypicalResponseTimeMessage = require('../../typical-response-time/publishTypicalResponseTimeMessage');

var _getWidgetAvailabilityOptions = require('../selectors/getWidgetAvailabilityOptions');

var _getThreadByChannel = require('../../threads/selectors/getThreadByChannel');

var _historyDataForThread = require('../../thread-histories/selectors/historyDataForThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function publish(_ref) {
  var channel = _ref.channel,
      state = _ref.state,
      dispatch = _ref.dispatch;

  var availabilityOptions = (0, _getWidgetAvailabilityOptions.getWidgetAvailabilityOptions)(state);
  var officeHoursStartTime = (0, _getOfficeHoursStartTime.getOfficeHoursStartTime)(availabilityOptions);
  var typicalResponseTime = (0, _getTypicalResponseTime.getTypicalResponseTime)(availabilityOptions);
  var shouldPublishOfficeHoursMessage = !!officeHoursStartTime;
  var shouldPublishTypicalResponseTimeMessage = !!typicalResponseTime;

  var thread = (0, _getThreadByChannel.getThreadByChannel)(state, { channel: channel });
  var threadHistory = (0, _historyDataForThread.historyDataForThread)(state, { thread: thread });

  if (shouldPublishOfficeHoursMessage) {
    if ((0, _canSendNewOfficeHoursMessage.canSendNewOfficeHoursMessage)(threadHistory)) {
      dispatch((0, _publishOfficeHoursMessage.publishOfficeHoursMessage)({ channel: channel }));
    }
  } else {
    if (shouldPublishTypicalResponseTimeMessage) {
      if ((0, _canSendNewTypicalResponseTimeMessage.canSendNewTypicalResponseTimeMessage)(threadHistory)) {
        dispatch((0, _publishTypicalResponseTimeMessage.publishTypicalResponseTimeMessage)({
          channel: channel
        }));
      }
    }
  }
}

var publishAvailabilityMessage = exports.publishAvailabilityMessage = function publishAvailabilityMessage(channel) {
  return function (dispatch, getState) {
    var conversations = (0, _getConversations.getConversations)(getState());

    var thread = (0, _getIn2.default)([channel], conversations);

    var threadHistory = (0, _historyDataForThread.historyDataForThread)(getState(), { thread: thread });

    if (threadHistory && (0, _hasChatMessageFromAgent.hasChatMessageFromAgent)(threadHistory)) {
      return;
    }

    publish({ channel: channel, state: getState(), dispatch: dispatch });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/availability/actions/publishAvailabilityMessage.js
// module id = 391
// module chunks = 2 3